module.exports = __webpack_public_path__ + "static/Maira-Lopez-2730cac3af26c32e315e94d3b0de6c4f.png";